import { ReactNode } from 'react';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const sizes: Record<string, string> = {
  sm: 'max-w-md',
  md: 'max-w-lg',
  lg: 'max-w-2xl',
  xl: 'max-w-4xl',
};

export default function Modal({ open, onClose, title, children, size = 'md' }: ModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose}></div>
      <div className={`relative bg-white rounded-2xl shadow-2xl w-full ${sizes[size]} mx-4 max-h-[85vh] flex flex-col z-10`}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-background-100">
          <h3 className="text-lg font-semibold text-foreground-900">{title}</h3>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-lg bg-background-100 hover:bg-background-200 flex items-center justify-center cursor-pointer transition-colors"
          >
            <i className="ri-close-line text-foreground-600"></i>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-5">{children}</div>
      </div>
    </div>
  );
}